import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { KanbanCacheStatus } from './cacheStatus';
import { KanbanBoardDetails } from './details';
import { KanbanBoardEdit } from './edit';
import { KanbanBoardsOverview } from './overview';
import { KanbanBoardTest } from './test';
import { KanbanBoardsTmp1 } from './tmp1';
import { MobileActionPage } from './mobileActionPage';

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class KanbanBoardsPageComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {}

  render() {
    if (this.props.work) return <Loader small />;
    return (
      <Container>
        <Switch>
          <Route path="(.*)/boards/tmp1" render={component => <KanbanBoardsTmp1 />} />
          <Route path="(.*)/boards/test" render={component => <KanbanBoardTest />} />

          <Route path="(.*)/boards/cache-status" render={component => <KanbanCacheStatus />} />
          <Route
            path="(.*)/boards/:board_id/action-page/:vehicleId(.*)"
            exact
            // render={component => <WS2_1_Interior_mobile_page vehicle={vehicle} action={this.props.action} />}
            render={component => <MobileActionPage vehicleId={component.match.params.vehicleId} />}
          />
          <Route
            path="(.*)/boards/:board_id/generic-inspection/:vehicleId(.*)"
            // render={component => <WS2_1_Interior_mobile_page vehicle={vehicle} action={this.props.action} />}
            render={component => <MobileActionPage vehicleId={component.match.params.vehicleId} genericInspection={true} />}
          />
          <Route
            path="(.*)/boards/:id(.*)/edit"
            render={component => <KanbanBoardEdit board_id={component.match.params.id} />}
          />
          <Route
            path="(.*)/boards/:id(.*)"
            render={component => <KanbanBoardDetails board_id={component.match.params.id} />}
          />

          <Route component={KanbanBoardsOverview} />
        </Switch>
      </Container>
    );
  }
}

KanbanBoardsPageComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const KanbanBoardsPage = compose(withConnect, withRouter)(KanbanBoardsPageComp);
